import { render, staticRenderFns } from "./statistics_activity.vue?vue&type=template&id=445ac842&scoped=true&"
import script from "./statistics_activity.vue?vue&type=script&lang=js&"
export * from "./statistics_activity.vue?vue&type=script&lang=js&"
import style0 from "./statistics_activity.vue?vue&type=style&index=0&id=445ac842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ac842",
  null
  
)

export default component.exports